const SemajFeaturesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature / Placement</p>
            <a href="https://open.spotify.com/track/55pVAmXrwyFiBr9tKSCHVQ?si=8e237705f25c48bc" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - fall into the crossfade (feat. Semaj)</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div> 

        </div>
      </>
    );
  };
  export default SemajFeaturesStatic;